import '../../sass/components/_modal.scss';

const modalTogglers = document.querySelectorAll( '[data-modal]' );
const modalClosers = document.querySelectorAll( '[data-modal-close]' );
if ( modalTogglers ) {
	modalTogglers.forEach( function( element ) {
		const target = element.getAttribute( 'data-modal' );
		const targets = document.querySelectorAll( target );
		element.addEventListener( 'click', ( event ) => {
			event.preventDefault();
			targets.forEach( function( e ) {
				e.showModal();
				const focus = e.querySelector( 'input' );
				if ( focus ) {
					focus.focus();
				}
			} );
		} );
	} );
	modalClosers.forEach( function( element ) {
		element.addEventListener( 'click', () => {
			const dialog = element.closest( 'dialog' );
			dialog.close();
		} );
	} );

	const modalDialogs = document.querySelectorAll( 'dialog' );
	modalDialogs.forEach( function( element ) {
		element.addEventListener( 'keydown', event => {
			if ( 'Enter' === event.key ) {
				event.preventDefault();
				element.querySelector( 'form' ).dispatchEvent( new Event( 'submit' ) );
			}
		} );
		element.addEventListener( 'click', function( event ) {
			if ( 'mouse' === event.pointerType ) {
				const rect = element.getBoundingClientRect();
				if ( event.clientY < rect.top || event.clientY > rect.bottom ||
					event.clientX < rect.left || event.clientX > rect.right ) {
					element.close();
				}
			}
		} );
	} );

}